import React from "react";
import classNames from "classnames";

export interface CardFooterProps {
    className?: string;
    muted?: boolean;
    children?: any;
    [x: string]: any;
}

export const CardFooter = ({
    className,
    muted,
    children,
    ...props
}: CardFooterProps) => (
    <div
        className={classNames("card-footer", className, {
            "text-muted": muted,
        })}
        {...props}
    >
        {children}
    </div>
);
